import { render, staticRenderFns } from "./Student.vue?vue&type=template&id=f4c7f9a4"
import script from "@/views/Users/Student/Student.ts?vue&type=script&lang=ts&external"
export * from "@/views/Users/Student/Student.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Users/Student/student.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports